// extracted by mini-css-extract-plugin
export var notFound = "notFound-module--not-found--0255c";